import * as yup from "yup";
export interface IJobOpening {
  id?: number,
  draft_Id?: number,
  business_Process_Id: number;
  payroll_Company_Id: number;
  branch_Id: number;
  department_Id: number;
  job_Profile: number;
  number_Of_Openings: number;
  job_Opening_Date: Date,
  job_Closing_Date: Date,
  employement_Type_Id: number,
  expected_Date_Of_Joining: Date,
  urgency_Level: number,
  work_Mood: number,
  experience_From: number,
  experience_To: number,
  salaryRangeMin: number,
  salaryRangeMax: number,
  jobSummary: string,
  CreatedAt?: Date,
}

export const emptyJobOpening: any = {
  business_Process_Id: 0,
  payroll_Company_Id: 0,
  branch_Id: 0,
  department_Id: 0,
  job_Profile: 0,
  number_Of_Openings: null,
  job_Opening_Date: new Date(),
  job_Closing_Date: new Date(),
  employement_Type_Id: 0,
  expected_Date_Of_Joining: new Date(),
  urgency_Level: 0,
  work_Mood: 0,
  experience_From: null,
  experience_To: null,
  salaryRangeMin: null,
  salaryRangeMax: null,
  jobSummary: "",
};

export interface JobOpeningCardProps {
  jobData?: any;
  handleDrawer: (value: boolean) => void;
  loadJobOpening: () => void;
};

export const schema = yup.object().shape({
  business_Process_Id: yup.number().typeError("Business Process is required").required("Business Process is required").min(1, "Business Process is required"),
  payroll_Company_Id: yup.number().typeError("Payroll Company is required").required("Payroll Company is required").min(1, "Payroll Company is required"),
  branch_Id: yup.number().typeError("Branch is required").required("Branch is required").min(1, "Branch is required"),
  department_Id: yup.number().typeError("Department is required").required("Department is required").min(1, "Department is required"),
  job_Profile: yup.number().typeError("Job Profile is required").required("Job Profile is required").min(1, "Job Profile is required"),
  number_Of_Openings: yup.number().typeError("Please enter a valid number").required("Number of openings is required").positive("Number of openings must be greater than 0").integer("Number of openings must be an integer"),
  job_Opening_Date: yup.date().typeError("Job Opening Date is required").required("Job Opening Date is required"),
  job_Closing_Date: yup.date().typeError("Job Closing Date is required").required("Job Closing Date is required").min(yup.ref("job_Opening_Date"), "Job Closing Date cannot be before Job Opening Date"),
  employement_Type_Id: yup.number().typeError("Employment Type is required").required("Employment Type is required").min(1, "Employment Type is required"),
  expected_Date_Of_Joining: yup.date().typeError("Expected Date Of Joining is required").required("Expected Date Of Joining is required").min(yup.ref("job_Opening_Date"), "Expected Date of Joining cannot be before Job Opening Date"),
  urgency_Level: yup.number().typeError("Urgency Level is required").required("Urgency Level is required").min(1, "Urgency Level is required"),
  work_Mood: yup.number().typeError("Work Mode is required").required("Work Mode is required").min(1, "Work Mode is required"),
  experience_From: yup.number().transform((value) => (value > 50 ? 50 : value)).typeError("Min Experience must be a number").required("Min Experience is required").min(0, "Min Experience cannot be negative").max(99, "Max Experience cannot exceed 2 digits").integer("Min Experience must be an integer"),
  experience_To: yup.number().transform((value) => (value > 50 ? 50 : value)).typeError("Max Experience must be a number").required("Max Experience is required").min(0, "Max Experience cannot be negative").max(99, "Max Experience cannot exceed 2 digits").integer("Max Experience must be an integer").test(
    "greaterThanMin",
    "Max Experience must be greater than or equal to Min Experience",
    function (value) {
      const { experience_From } = this.parent;
      if (value === undefined || experience_From === undefined) return true;
      return value >= experience_From;
    }
  ),
  salaryRangeMin: yup.number().typeError("Salary Range must be a number").required("Salary Range is required").min(0, "Salary Range cannot be negative").integer("Salary Range must be an integer"),
  salaryRangeMax: yup.number().typeError("Salary Range must be a number").required("Salary Range is required").min(0, "Salary Range cannot be negative").integer("Salary Range must be an integer")
    .test(
      "greaterThanMinSalary",
      "Max Salary must be greater than or equal to Min Salary",
      function (value) {
        const { salaryRangeMin } = this.parent;
        if (value === undefined || salaryRangeMin === undefined) return true;
        return value >= salaryRangeMin;
      }
    ),
  jobSummary: yup.string().transform((value) => { if (!value) return "";
      return value.replace(/<p><br><\/p>/gi, "").replace(/<p>\s*<\/p>/gi, "").replace(/&nbsp;/gi, "").replace(/<[^>]*>/g, "").trim(); })
    .test( "job-summary-required", "Job Description is required", (value) => !!value && value.trim().length > 0 ) .required("Job Description is required")
});


export const urgencyLevelOptions = [
  { id: "1", label: "High" },
  { id: "2", label: "Medium" },
  { id: "3", label: "Low" },
];